import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { DriverStatusCssClasses } from "../DriversUIHelpers";
import * as actions from "../../_redux/driversActions";
import { useDriversUIContext } from "../DriversUIContext";

const selectedDrivers = (entities, ids) => {
  const _drivers = [];
  ids.forEach((id) => {
    const driver = entities.find((el) => el.id === id);
    if (driver) {
      _drivers.push(driver);
    }
  });
  return _drivers;
};

export function DriversUpdateStateDialog({ show, onHide }) {
  // Drivers UI Context
  const driversUIContext = useDriversUIContext();
  const driversUIProps = useMemo(() => {
    return {
      ids: driversUIContext.ids,
      setIds: driversUIContext.setIds,
      queryParams: driversUIContext.queryParams,
    };
  }, [driversUIContext]);

  // Drivers Redux state
  const { drivers, isLoading } = useSelector(
    (state) => ({
      drivers: selectedDrivers(
        state.drivers.entities,
        driversUIProps.ids
      ),
      isLoading: state.drivers.actionsLoading,
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!driversUIProps.ids || driversUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driversUIProps.ids]);

  const [status, setStatus] = useState(0);

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for update drivers status by selected ids
    dispatch(actions.updateDriversStatus(driversUIProps.ids, status)).then(
      () => {
        // refresh list after deletion
        dispatch(actions.fetchDrivers(driversUIProps.queryParams)).then(
          () => {
            // clear selections list
            driversUIProps.setIds([]);
            // closing delete modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Status has been updated for selected drivers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block cursor-default">
        {/*begin::Loading*/}
        {isLoading && (
          <div className="overlay-layer">
            <div className="spinner spinner-lg spinner-primary" />
          </div>
        )}
        {/*end::Loading*/}

        <div className="timeline timeline-5 mt-3">
          {drivers.map((driver) => (
            <div
              className="timeline-item align-items-start"
              key={`driversUpdate${driver.id}`}
            >
              <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg text-right pr-3" />
              <div className="timeline-badge">
                <i
                  className={`fa fa-genderless text-${
                    DriverStatusCssClasses[driver.status]
                  } icon-xxl`}
                />
              </div>
              <div className="timeline-content text-dark-50 mr-5">
                <span
                  className={`label label-lg label-light-${
                    DriverStatusCssClasses[driver.status]
                  } label-inline`}
                >
                  ID: {driver.id}
                </span>
                <span className="ml-3">
                  {driver.lname}, {driver.fname}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="form">
        <div className="form-group">
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(+e.target.value)}
          >
            <option value="0">Suspended</option>
            <option value="1">Active</option>
            <option value="2">Pending</option>
          </select>
        </div>
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mr-3"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={updateStatus}
            className="btn btn-primary btn-elevate"
          >
            Update Status
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
